export const START_USAGE_THRESHOLD_DATE = '2026-04-01'
export const MAX_WARNING_UNIT_ACQUISITION_COST = 400000
export const MIN_WARNING_UNIT_ACQUISITION_COST = 300000
